import { Link } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom/dist";
import {
  avatar01,
  doctor_thumb_01,
  logo,
  logoSmall,
  patient1,
} from "../imagepath";
import { deleteUser, getUser } from "../../services/storage";
import { AppContext, initialUser } from "../../services/context";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import "./header.css";
import { baseApiUrl } from "../../services/api";


const Header = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const authCtx = useContext(AppContext);
  const { user, onUserChange } = authCtx;
  const [userLocal, setUserLocal] = useState("");
  let navigate = useNavigate();

  useEffect(() => {
    setUserLocal(getUser());
    isAuth();
  }, [user]);

  const isAuth = () => {
    if (!user.isAuth || !user.token) {
      console.log("Connexion échouée");
    } else {
      console.log("Utilisateur authentifié");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded);
      } catch (error) {
        console.error("Erreur lors du décodage du token:", error);
      }
    }
  }, []);

  const handleLogout = async () => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        await baseApiUrl.post(
          "/compte/deconnexion",
        
        );
        console.log("Déconnexion réussie sur le serveur");
      } catch (error) {
        console.error("Erreur lors de la déconnexion sur le serveur:", error);
      }
    }

    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    onUserChange(initialUser);
    navigate("/");
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const handlesidebarmobilemenu = () => {
    document.body.classList.toggle("slide-nav");
  };

  return (
    <>
      <div className="header ">
        <div className="header-left">
          <Link to="/admin" className="logo">
            <img 
            src={`${process.env.PUBLIC_URL}/assets/img/logo/ab2i.jpg`} alt="Logo" 
            height="40"/>
            
          </Link>
          {/* <Link to="/" className="logo logo-small">
            <img src={logoSmall} alt="Logo" width="30" height="30" />
          </Link> */}
        </div>
        <Link to="#" id="toggle_btn" onClick={handlesidebar}>
          <i className="fe fe-text-align-left"></i>
        </Link>
        <Link
          to="#"
          className="mobile_btn"
          id="mobile_btn"
          onClick={handlesidebarmobilemenu}
        >
          <i className="fa fa-bars" />
        </Link>

        <ul className="nav user-menu" style={{ marginLeft: "20px" }}>
          {/* Notifications */}
          <li
            className="nav-item dropdown noti-dropdown"
            style={{ marginRight: "20px" }}
          >
            <button
              className="nav-link"
              onClick={() => setIsNotificationOpen(!isNotificationOpen)}
              style={{
                background: "none",
                border: "none",
                position: "relative",
              }}
            >
              <i
                className="fe fe-bell clignote"
                style={{
                  fontSize: "24px",
                  position: "relative",
                  animation: "clignoter 1s infinite",
                  color: "red",
                }}
              />
              <span
                className="badge rounded-pill"
                style={{
                  position: "absolute",
                  top: "-4px",
                  right: "5px",

                  color: "black",
                }}
              >
                3
              </span>
            </button>

            {isNotificationOpen && (
              <div
                className="dropdown-menu notifications show"
                style={{ width: "220px", marginLeft: "-100px" }}
              >
                <div className="topnav-dropdown-header">
                  <span className="notification-title">Notifications</span>
                  <Link to="#" className="clear-noti">
                    {" "}
                    Effacer tout{" "}
                  </Link>
                </div>
                <div className="noti-content">
                  <ul className="notification-list">
                    <li className="notification-message">
                      <Link to="#">
                        <div className="media d-flex">
                          <span className="avatar avatar-sm flex-shrink-0">
                            <img
                              className="avatar-img rounded-circle"
                              alt="User"
                              src={doctor_thumb_01}
                            />
                          </span>
                          <div className="media-body flex-grow-1">
                            <p className="noti-details">
                              <span className="noti-title">Ruby Perrin</span>{" "}
                              Schedule
                            </p>
                            <p className="noti-time">
                              <span className="notification-time">4 mins</span>
                            </p>
                          </div>
                        </div>
                      </Link>
                    </li>
                    <li className="notification-message">
                      <Link to="#">
                        <div className="media d-flex">
                          <span className="avatar avatar-sm flex-shrink-0">
                            <img
                              className="avatar-img rounded-circle"
                              alt="User"
                              src={patient1}
                            />
                          </span>
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="topnav-dropdown-footer">
                  <Link to="#">Voir toutes les Notifications</Link>
                </div>
              </div>
            )}
          </li>
          {/* /Notifications */}

          {/* User Menu */}
          <li
            className="nav-item dropdown has-arrow"
            style={{ marginRight: "30px" }}
          >
            <button
              className="nav-link"
              onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
              style={{ background: "none", border: "none" }}
            >
              <span className="user-img">
                <img
                  className="rounded-circle"
                  src={
                    currentUser && currentUser.photo
                        ? baseApiUrl.defaults.baseURL + `/image/${currentUser.photo}`
                        : "https://via.placeholder.com/30"
                    }
                  width={33}
                  style={{ fontSize: "24px" }}
                  alt="User"
                />
              </span>
            </button>
            {isUserMenuOpen && (
              <div
                className="dropdown-menu show"
                style={{ width: "215px", marginLeft: "-150px" }}
              >
                <div className="user-header">
                  <div className="avatar avatar-sm">
                    <img
                      src={
                        currentUser && currentUser.photo
                            ? baseApiUrl.defaults.baseURL +`/image/${currentUser.photo}`
                            : "https://via.placeholder.com/30"
                        }
                      alt="User"
                      className="avatar-img rounded-circle"
                    />
                  </div>
                  <div className="user-text">
                    <h6>DA</h6>
                    <p className="text-muted mb-0">{currentUser?.nom}</p>
                  </div>
                </div>
                <Link className="dropdown-item" to="/dashboard/profile">
                  Mon Profile
                </Link>
                {/* <Link className="dropdown-item" to="/settings">
                  Paramètre
                </Link> */}
                {/* <button
                  className="dropdown-item"
                  onClick={handleLogout}
                  style={{ border: "none", background: "none" }}
                >
                  Se déconnecter
                </button> */}

            <Link
                className="dropdown-item"
                to="/"
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout();
                
                }}
              >
                Se déconnecter
              </Link>
              </div>
            )}
          </li>
          {/* /User Menu */}
        </ul>
      </div>
    </>
  );
};

export default Header;
